import ApiService from './api.service';
import TokenService from './storage.service';

class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const loginService = {
  async login() {
    const loginData = `grant_type=client_credentials&scope=broker-360-api&client_id=${window.clientId}&client_secret=${window.clientSecret}`;
    try {
      const response = await ApiService.loginRequest(loginData);
      TokenService.saveToken(response.data.access_token, response.data.expires_in);
      // TokenService.saveRefreshToken(response.data.refresh_token);
      // ApiService.mount401Interceptor();
      return response.data.access_token;
    } catch (error) {
      throw new AuthenticationError(error.response.status, error.response.data.detail);
    }
  },
};

export default loginService;
